import log from 'salvo-lite/log'
import { getSizedImageUrl, getPrice } from '../helpers/shopify'
import axios from 'axios'

class CartUpdate {
    constructor(theme, elem) {
        this.theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-cart-update'))
        this._action = this._data.action || 'add'
        this._event = this._data.event || 'click'
        this._product = this._elem.closest('[data-product]')
        this._cartSelector = this._data._cartSelector || '.slideout-cart'
        this._cart = document.querySelector(this._cartSelector)
        this._cartItemSelector = this._data._cartItemSelector || '.cart-item'
        this._delay = this._data.delay || 0
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit() {
        this._elem.addEventListener(this._event, e => {
            e.preventDefault()
            setTimeout(() => {
                const variantID = this._data.variantID || parseInt(this._product.querySelector('[data-product-selected-variant]').value)
                this[`_${this._action}`](variantID)
            }, this._delay)
        })
    }

    _add(variantID) {
        const quantity = (this._product && this._product.querySelector('[data-product-quantity]')) ? parseInt(this._product.querySelector('[data-product-quantity]').value) : 1

        // check if product already exists in cart
        axios.get('/cart.js').then((response) => {
            let alreadyExists = false
            const items = response.data.items
            for (let i = 0; i < items.length; i++) {
                const itemID = items[i].variant_id
                if (itemID === variantID) {
                    alreadyExists = true
                }
            }

            // add product to cart
            axios.post('/cart/add.js', {
                quantity: quantity,
                id: variantID
            }).then(response => {
                console.log(response)
                if (alreadyExists) {
                    this._cart.querySelector(`[data-product="${variantID}"] [data-product-quantity]`).value = parseInt(this._cart.querySelector(`[data-product="${variantID}"] [data-product-quantity]`).value) + 1
                    this._updateCartCount()
                    this._shippingOfferQuantity()
                    this._shippingOfferPrice()
                    this._openCart()
                    this._updateCartTotal()
                    this._updateBasketItemQuantity(variantID, quantity)
                } else {
                    this._addCartItem(response.data)
                    this._shippingOfferQuantity()
                    this._shippingOfferPrice()
                    this._updateCartCount()
                    this._updateCartTotal()
                    this._updateBasketItemQuantity(variantID, quantity)
                }
            }).catch(error => {
                console.error(error)
            })
        })
    }

    _shippingOfferQuantity() {
        if (this._cart.getAttribute('data-shipping-min')) {
            const minItemsNeeded = parseInt(this._cart.getAttribute('data-shipping-min'))
            axios.get('/cart.js').then(response => {
                const remainingItemsNeeded = minItemsNeeded - response.data.item_count
                if (remainingItemsNeeded <= 0) {
                    this._cart.classList.remove('shipping-offer--not-met')
                } else {
                    this._cart.classList.add('shipping-offer--not-met')
                }
                document.querySelector('.shipping-remaining-amount').textContent = remainingItemsNeeded
            })
        }
    }

    _shippingOfferPrice() {
        const shippingSpendText = document.getElementById('spend-more-shipping-text')
        const shippingThreshold = document.getElementById('spend-more-amount')
        if (shippingSpendText !== null && shippingThreshold !== null && shippingThreshold.getAttribute('data-threshold')) {
            const minSpendNeeded = parseFloat(shippingThreshold.getAttribute('data-threshold')).toFixed(2)
            axios.get('/cart.js').then(response => {
                const remainingSpendNeeded = (minSpendNeeded - (response.data.total_price / 100)).toFixed(2)
                if (remainingSpendNeeded <= 0) {
                    shippingSpendText.classList.add('hidden')
                } else {
                    shippingSpendText.classList.remove('hidden')
                }
                shippingThreshold.textContent = remainingSpendNeeded
            })
        }
    }

    _addCartItem(product) {
        const cartItems = this._cart.querySelector('.cart-items')
        console.log(product)
        const image = getSizedImageUrl(product.image, '180x')
        const newCartItem = document.createElement('div')
        // const maxQuantity = parseInt(this._product.querySelector('[data-max-quantity]').getAttribute('data-max-quantity'))
        newCartItem.classList.add('cart-item')
        newCartItem.setAttribute('data-product', product.id)
        let newCartItemShippingOfferText = '';
        if (document.querySelector('.slideout-cart__list').classList.contains('quantity-based-offer-active')) {
            newCartItemShippingOfferText = '<p class="cart-item__shipping-info cart-item__shipping-info--offer">Add <span class="shipping-remaining-amount"></span> more for free shipping</p><p class="cart-item__shipping-info cart-item__shipping-info--offer-success">Includes free shipping</p>';
        }

        let newCartItemHTML = `
            <a href="${product.url}" class="cart-item__image object-cover">
                <img src="${image}">
            </a>
            <div class="cart-item__info">
                <h2 class="cart-item__title">${product.title}</h2>
                <div class="cart-item__supply">${document.querySelector('[data-product-supply]') ? document.querySelector('[data-product-supply]').innerHTML : ''}</div>
                <p class="product-price cart-item__price">${getPrice(product.price)}</p>
                <div class="cart-item__quantity-row flex f-vertical-center">
                    <h3 class="cart-item__quantity-title bold">Quantity</h3>
                    <div class="product-quantity flex f-vertical-center">
                        <button class="product-quantity__button" data-quantity='{ "action": "decrease" }'><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="4" viewBox="0 0 17 4"><g><g><image width="17" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAECAYAAABodtTSAAAAG0lEQVQoU2OUk5NpYKAQMMrKSv+n0AyGwWMIAAIRBNnhCmQtAAAAAElFTkSuQmCC"/></g></g></svg></button>
                        <input disabled class="product-quantity__input" data-quantity='{ "event": "keyup" }' data-cart-update='{ "event": "change", "action": "updateQuantity", "variantID": ${product.variant_id} }' data-product-quantity type="number" value="${product.quantity}" data-cart-update='{ "action": "updateQuantity", "variantID": ${product.variant_id}, "event": "change" }'>
                        <button class="product-quantity__button" data-quantity='{ "action": "increase" }'><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="17" viewBox="0 0 17 17"><g><g><image width="17" height="17" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAWElEQVQ4T2NkwAFkZaUCGBgY1yOk/wc+fvxsAzbljKOGYIQAdcIEEguY4P9/BnNGRsYKmMz///87GBkZTmKNHVlZ6f+4YohYccbBZAgVwmQ0xdIoxVIjYAG2wVtWNSGqQwAAAABJRU5ErkJggg=="/></g></g></svg></button>
                    </div>
                </div>
                <p class="cart-item__shipping-info">Shipping will be added at checkout</p>
                ${newCartItemShippingOfferText}
                <button class="xs cart-item__remove" data-cart-update='{ "action": "remove", "variantID":  ${product.variant_id} }'>X Remove</button>
            </div>
        `

        newCartItem.innerHTML = newCartItemHTML

        cartItems.appendChild(newCartItem)
        this._cart.classList.remove('cart-empty')
        this._openCart()

        this.theme.registerComponents(newCartItem)
    }

    _remove(variantID, ui = true) {
        const self = this
        axios.post('/cart/update.js', {
            updates: {
                [variantID]: 0
            }
        }).then((response) => {
            console.log(response, '--- remove response')
            // Check if all items have been removed
            let variantRemaining = false;
            response.data.items.forEach(item => {
                if (item.variant_id == variantID) {
                    variantRemaining = true
                    return
                }
            })
            if (variantRemaining) {
                console.log('running remove again')
                this._remove(variantID)
            } else {
                self._updateCartTotal(response.data)
                self._updateCartCount()
                this._shippingOfferQuantity()
                this._shippingOfferPrice()
                if (ui) {
                    self._removeCartItem(variantID)
                }
                if (response.data.item_count === 0) {
                    const cart = document.querySelector(this._cartSelector)
                    cart.classList.add('cart-empty')
                }
            }
        }).catch(function (error) {
            console.error(error)
        })
    }

    _removeCartItem(variantID) {
        this._elem.closest(this._cartItemSelector).remove()
    }

    _updateQuantity(variantID) {
        let quantity = parseInt(this._elem.value) || parseInt(this._product.querySelector('[data-product-quantity]').value)

        if (this._product.classList.contains('cart-item--bogof')) {
            axios.get('/cart.js').then((response) => {
                const matchingCartItem = response.data.items.find(({ id }) => id === variantID)
                const originalQuantity = matchingCartItem.quantity
                console.log('matchingCartItem, originalQuantity, quantity', matchingCartItem, originalQuantity, quantity)

                const freeCartItem = response.data.items.find(({ id, discounted_price }) => id === variantID && discounted_price === 0)
                const freeCartItemQuantity = freeCartItem.quantity

                const originalTotalQuantity = originalQuantity + freeCartItemQuantity
                console.log('originalTotalQuantity, quantity', originalTotalQuantity, quantity)
                if (quantity % 2 !== 0) {
                    if (quantity > originalTotalQuantity) {
                        quantity += 1
                        quantity /= 2
                    } else {
                        quantity -= 1
                        quantity /= 2
                    }
                } else {
                    if (quantity > originalTotalQuantity) {
                        quantity /= 2
                        quantity += 1
                    } else {
                        quantity /= 2
                    }
                }

                axios.post('/cart/update.js', {
                    updates: {
                        [variantID]: quantity
                    }
                }).then(response => {
                    console.log('success', response)
                    this._updateCartTotal(response.data)
                    this._updateCartCount()
                    this._shippingOfferQuantity()
                    this._shippingOfferPrice()
                    if (quantity <= 0) {
                        this._removeCartItem(variantID)
                    }
                }).catch(function (error) {
                    console.error(error)
                })
            })
        } else {
            axios.post('/cart/update.js', {
                updates: {
                    [variantID]: quantity
                }
            }).then(response => {
                console.log('success', response)
                this._updateCartTotal(response.data)
                this._shippingOfferQuantity()
                this._shippingOfferPrice()
                this._updateCartCount()
                if (quantity <= 0) {
                    this._removeCartItem(variantID)
                }
            }).catch(function (error) {
                console.error(error)
            })
        }
    }

    _updateCartTotal(cart = false) {
        console.log('UPDATING CART TOTAL')
        if (!cart) {
            console.log('..1')
            axios.get('/cart.js').then((response) => {
                cart = response.data
                const cartTotalElems = document.querySelectorAll('[data-cart-total]')
                if (cartTotalElems.length) {
                    for (let i = 0; i < cartTotalElems.length; i++) {
                        cartTotalElems[i].textContent = getPrice(cart.total_price, cart.currency)
                    }
                }
            })
        } else {
            console.log('..2')
            const cartTotalElems = document.querySelectorAll('[data-cart-total]')
            if (cartTotalElems.length) {
                for (let i = 0; i < cartTotalElems.length; i++) {
                    cartTotalElems[i].textContent = getPrice(cart.total_price, cart.currency)
                }
            }
        }
    }

    _updateCartCount(cart) {
        axios.get('/cart.js').then((response) => {
            const cartItemCount = response.data.item_count
            const cartIcons = document.querySelectorAll('[data-cart-count]')
            for (let i = 0; i < cartIcons.length; i++) {
                const cartIcon = cartIcons[i]
                if (cartItemCount > 0) {
                    if (!cartIcon.classList.contains('has-items')) {
                        cartIcon.classList.add('has-items')
                    }
                    cartIcon.setAttribute('data-cart-count', cartItemCount)
                } else {
                    cartIcon.setAttribute('data-cart-count', '')
                    if (cartIcon.classList.contains('has-items')) {
                        cartIcon.classList.remove('has-items')
                    }
                }
            }
        })
    }

    _openCart() {
        document.body.classList.add('cart-open')
        this._cart.parentNode.classList.add('infront')
    }

    _updateBasketItemQuantity(variantID, quantity) {
        // Find basket item with matching variant ID
        let basketItemToEdit = null
        const basketItems = document.querySelectorAll('.cart-item')
        for (let i = 0; i < basketItems.length; i++) {
            const basketItem = basketItems[i]
            if (basketItem.getAttribute('data-product') == variantID) {
                basketItemToEdit = basketItem;
                break;
            }
        }
        // Update .product-quantity__input val & inner text to quantity
        if (basketItemToEdit != null) {
            const quantityElem = basketItemToEdit.querySelector('.product-quantity__input')
            quantityElem.value = quantity
        }
    }
}

export default CartUpdate



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartUpdate.js